import { axios_instance } from "@/api/api";
import type { Client, ClientsFilters } from "@/types/clients";
import type { PaginationResponse } from "@/types/serverResponse";
import dayjs from "dayjs";
import { toast } from "vue3-toastify";

export const getClients = async (
  filters: ClientsFilters,
): Promise<PaginationResponse<Client>> => {
  try {
    const body = {
      ...filters,
      time_from: filters.startDate
        ? dayjs(filters.startDate).unix() * 1000
        : undefined,
      time_to: filters.endDate
        ? dayjs(filters.endDate).unix() * 1000
        : undefined,
      time_field: filters.startDate || filters.endDate ? "created" : undefined,
    };
    delete body.startDate;
    delete body.endDate;

    const response = await axios_instance.post<PaginationResponse<Client>>(
      "/api/v1/view/agent",
      body,
    );
    return response.data;
  } catch (err: unknown) {
    toast.error(err);
    return {
      data: null,
      total_filter: 0,
    };
  }
};

export const deleteClient = async (id: string): Promise<void> => {
  try {
    await axios_instance.delete(`/api/v1/view/agent/${id}`);
    toast.success("Xóa máy trạm thành công!");
  } catch (err: unknown) {
    toast.error(err);
    throw err;
  }
};
